// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.softlite-background-tab-setting{
    width: 50%;
    justify-content: center;
    font-weight: 400;
    height: 30px;
}
.softlite-background-tab-panel>div:nth-child(1){
    border: 1px solid #dedede;
    transition: all .3s;
}
.softlite-background-tab-panel .components-panel__body{
     border-top: none;
}
.softlite-background-tab-setting.active-tab{
    background-color: #1e1e1e;
    color: #fff;
}
.softlite-background-tab-panel button.softlite-background-tab-setting{
    transition: all .2s;
}
.softlite-background-tab-panel .components-panel__body{
    padding: 15px 5px !important;
}
.softlite-button-choose-image:focus{
    outline: none !important;
    box-shadow: none !important;
}
.softlite-text-inline-label>div:nth-child(1){
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.softlite-text-inline-label>div:nth-child(1)>label{
    margin-bottom: 0 !important;
    width: 40%;
    font-size: 13px !important;
    font-weight: 400;
    text-transform: capitalize;
}
.softlite-text-inline-label>div:nth-child(1)>input{
    width: 59%;
}
.softlite-button-remove-image.has-icon{
    min-width: 20px;
    width: 20px;
    height: 20px;
    min-height: 20px;
    background-color: #db0707;
    color: #fff;
    border-radius: 50%;
    padding: 0;
    margin: 0;
    border: none;
    outline: none;
    box-shadow: none;
    cursor: pointer;
    transition: all .3s;
}
.softlite-button-remove-image.has-icon:hover{
    background-color: red;
    color: #fff;
}`, "",{"version":3,"sources":["webpack://./assets/js/src/controls/background/background.css"],"names":[],"mappings":"AAAA;IACI,UAAU;IACV,uBAAuB;IACvB,gBAAgB;IAChB,YAAY;AAChB;AACA;IACI,yBAAyB;IACzB,mBAAmB;AACvB;AACA;KACK,gBAAgB;AACrB;AACA;IACI,yBAAyB;IACzB,WAAW;AACf;AACA;IACI,mBAAmB;AACvB;AACA;IACI,4BAA4B;AAChC;AACA;IACI,wBAAwB;IACxB,2BAA2B;AAC/B;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;AACA;IACI,2BAA2B;IAC3B,UAAU;IACV,0BAA0B;IAC1B,gBAAgB;IAChB,0BAA0B;AAC9B;AACA;IACI,UAAU;AACd;AACA;IACI,eAAe;IACf,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,yBAAyB;IACzB,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,SAAS;IACT,YAAY;IACZ,aAAa;IACb,gBAAgB;IAChB,eAAe;IACf,mBAAmB;AACvB;AACA;IACI,qBAAqB;IACrB,WAAW;AACf","sourcesContent":[".softlite-background-tab-setting{\r\n    width: 50%;\r\n    justify-content: center;\r\n    font-weight: 400;\r\n    height: 30px;\r\n}\r\n.softlite-background-tab-panel>div:nth-child(1){\r\n    border: 1px solid #dedede;\r\n    transition: all .3s;\r\n}\r\n.softlite-background-tab-panel .components-panel__body{\r\n     border-top: none;\r\n}\r\n.softlite-background-tab-setting.active-tab{\r\n    background-color: #1e1e1e;\r\n    color: #fff;\r\n}\r\n.softlite-background-tab-panel button.softlite-background-tab-setting{\r\n    transition: all .2s;\r\n}\r\n.softlite-background-tab-panel .components-panel__body{\r\n    padding: 15px 5px !important;\r\n}\r\n.softlite-button-choose-image:focus{\r\n    outline: none !important;\r\n    box-shadow: none !important;\r\n}\r\n.softlite-text-inline-label>div:nth-child(1){\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n}\r\n.softlite-text-inline-label>div:nth-child(1)>label{\r\n    margin-bottom: 0 !important;\r\n    width: 40%;\r\n    font-size: 13px !important;\r\n    font-weight: 400;\r\n    text-transform: capitalize;\r\n}\r\n.softlite-text-inline-label>div:nth-child(1)>input{\r\n    width: 59%;\r\n}\r\n.softlite-button-remove-image.has-icon{\r\n    min-width: 20px;\r\n    width: 20px;\r\n    height: 20px;\r\n    min-height: 20px;\r\n    background-color: #db0707;\r\n    color: #fff;\r\n    border-radius: 50%;\r\n    padding: 0;\r\n    margin: 0;\r\n    border: none;\r\n    outline: none;\r\n    box-shadow: none;\r\n    cursor: pointer;\r\n    transition: all .3s;\r\n}\r\n.softlite-button-remove-image.has-icon:hover{\r\n    background-color: red;\r\n    color: #fff;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
